<template>
    <div class="container">
        <div class="row">
            <div class="col-xs-6">
                <help-text>
                    <h3>
                        Create Subscription Type
                    </h3>

                    <p>
                        Enter the details of the subscription type.
                    </p>
                </help-text>
            </div>

            <div class="col-xs-18">
                <div class="panel panel-default">
                    <div class="panel-body">
                        <form @submit.prevent="submit" class="form-horizontal">
                            <text-form-group
                                v-model="data.name"
                                name="name"
                                label="Name"
                                help-text="The name of the subscription type."
                                :error="getError('name')"
                            ></text-form-group>

                            <number-form-group
                                v-model="data.price"
                                name="price"
                                label="Price"
                                help-text="The price of subscriptions with this type."
                                :error="getError('price')"
                            ></number-form-group>

                            <number-form-group
                                v-model="data.period"
                                name="period"
                                label="Period"
                                help-text="The period (in months) of subscriptions with this type."
                                :error="getError('period')"
                            ></number-form-group>

                            <number-form-group
                                v-model="data.closes_after"
                                name="closes_after"
                                label="Closes After"
                                help-text="The number of seats that subscriptions with this type will grant on the portal."
                                :error="getError('closes_after')"
                            ></number-form-group>

                            <number-form-group
                                v-model="data.seats"
                                name="seats"
                                label="Seats"
                                help-text="The number of seats in the subscription."
                                :error="getError('seats')"
                            ></number-form-group>

                            <hr>

                            <submit-form-group button-class="btn-black"></submit-form-group>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import http from '@/http'
import moment from 'moment'
import notify from '@/notify'
import Errors from '@/mixins/Errors'
import HelpText from '@/components/HelpText'
import NumberFormGroup from '@/vendor/forms/FormGroups/Horizontal/Number'
import SubmitFormGroup from '@/vendor/forms/FormGroups/Horizontal/Submit'
import TextFormGroup from '@/vendor/forms/FormGroups/Horizontal/Text'

export default {
    components: {HelpText, NumberFormGroup, SubmitFormGroup, TextFormGroup},

    mixins: [Errors],

    model: {
        prop: 'portal',
        event: 'portal-updated'
    },

    props: ['portal'],

    data() {
        return {
            data: {}
        }
    },

    methods: {
        submit() {
            http.post('/api/v2/subscription-types', {...this.data, portal_id: this.portal.id})
                .then(() => {
                    notify.success('The subscription type was saved')

                    this.$router.push('/portals/' + this.portal.id + '/subscription-types')
                })
                .catch(this.catchValidationErrors)
        }
    }
}
</script>
